module.exports = "/_next/static/images/proces-inzicht-0e6609620d3872a9c17860eab604628a.svg";